import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from "@ts-digital/vrc/es/components/modal";
import getFormattedMessageWithScope from "../../../utils/getFormattedMessageWithScope";
import { CustomButton } from "../CustomButton";
import "./style.css";

const fm = getFormattedMessageWithScope("components.PayNowModal");

interface PayNowModalProps {
    visible: boolean;
    onConfirm: Function;
    isPayNow: boolean;
}

export const PayNowModal = ({
    visible,
    onConfirm,
    isPayNow,
}: PayNowModalProps) => (
    <Modal
        className="c-PayNowModal"
        visible={visible}
        title={
            <span className="c-PayNowModal-title">
                {fm(isPayNow ? "payNowTitle" : "payOnDeadlineTitle")}
            </span>
        }
        onClose={onConfirm}
        footer={
            <div className="c-PayNowModal-footer">
                <div className="c-PayNowModal-footer-buttons">
                    <CustomButton kind="primary" onClick={onConfirm}>
                        {fm("confirm")}
                    </CustomButton>
                </div>
            </div>
        }
    >
        <div className="c-PayNowModal-content">
            {isPayNow ? (
                <div>
                    <p className="c-PayNowModal-content-line1">
                        {fm("payNowLine1")}
                    </p>
                    <p className="c-PayNowModal-content-line2">
                        {fm("payNowLine2")}
                    </p>
                </div>
            ) : (
                <div>
                    <p className="c-PayNowModal-content-line1">
                        {fm("payOnDeadlineLine1")}
                    </p>
                    <p className="c-PayNowModal-content-line2">
                        {fm("payOnDeadlineLine2")}
                    </p>
                    <p className="c-PayNowModal-content-expiredInstallmentsInfo">
                        <FontAwesomeIcon
                            icon={faInfoCircle as IconProp}
                            className="c-PayNowModal-content-expiredInstallmentsInfo-icon"
                        />{" "}
                        {fm("expiredInstallmentsInfo")}
                    </p>
                </div>
            )}
        </div>
    </Modal>
);
